import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { Link } from 'react-router-dom';

interface TestRunStat {
  testId: string;
  testName: string;
  totalRuns: number;
  successCount: number;
  failedCount: number;
  blockedCount: number;
  unreachableCount: number;
  crashedCount: number;
  skippedCount: number;
  inProgressCount: number;
  avgDuration: number | undefined;
  lastRun: string | undefined;
  errorMessages?: string[];
}

interface Props {
  projectId: string;
  stats: TestRunStat[];
}

export function TestRunStatsTable({ projectId, stats }: Props) {
  return (
    <Paper sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ p: 2 }}>
        Per-Test Run Statistics
      </Typography>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Test</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="right">Success</TableCell>
              <TableCell align="right">Failed</TableCell>
              <TableCell align="right">Blocked</TableCell>
              <TableCell align="right">Unreachable</TableCell>
              <TableCell align="right">Skipped</TableCell>
              <TableCell align="right">Crashed</TableCell>
              <TableCell align="right">In Progress</TableCell>
              <TableCell align="right">Avg Duration</TableCell>
              <TableCell align="right">Last Run</TableCell>
              <TableCell align="right">Errors</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stats.map((test) => (
              <TableRow key={test.testId}>
                <TableCell>
                  <Link to={`/projects/${projectId}/tests/${test.testId}`}>{test.testName}</Link>
                </TableCell>

                <TableCell align="right">{test.totalRuns}</TableCell>
                <TableCell align="right">
                  <Chip size="small" color="success" label={test.successCount} />
                </TableCell>
                <TableCell align="right">
                  <Chip size="small" color="error" label={test.failedCount} />
                </TableCell>
                <TableCell align="right">
                  <Chip size="small" color="warning" label={test.blockedCount} />
                </TableCell>
                <TableCell align="right">{test.unreachableCount}</TableCell>
                <TableCell align="right">{test.skippedCount}</TableCell>
                <TableCell align="right">{test.crashedCount}</TableCell>
                <TableCell align="right">{test.inProgressCount}</TableCell>
                <TableCell align="right">
                  {test.avgDuration ? `${test.avgDuration.toFixed(1)}s` : '–'}
                </TableCell>
                <TableCell align="right">
                  {test.lastRun ? new Date(test.lastRun).toLocaleString() : '–'}
                </TableCell>
                <TableCell align="right">
                  {test.errorMessages?.length ? (
                    <Tooltip
                      title={
                        <div style={{ maxWidth: 300 }}>
                          {test.errorMessages.map((msg, i) => (
                            <div key={i}>{msg}</div>
                          ))}
                        </div>
                      }
                    >
                      <Chip size="small" color="default" label={`${test.errorMessages.length} errors`} />
                    </Tooltip>
                  ) : (
                    '–'
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
